<script setup lang="ts">
const carousels = [
  {
    title: 'Kirim Paket COD',
    description: 'Melalui KiriminAja'
  },
  {
    title: 'Ajukan COD Advance',
    description: 'Langsung dari dashboard setelah pengiriman diverifikasi.'
  },
  {
    title: 'Dana Cair Sebagian',
    description:
      'Pencairan hingga 50% dari nilai barang sebelum paket diterima.'
  },
  {
    title: 'Pelunasan Otomatis',
    description: 'Sisa dana dicairkan begitu paket diterima pembeli. dana COD'
  }
]
</script>

<template>
  <div
    class="bg-surface-container-low dark:bg-surface-container-highest py-6 lg:py-16 relative overflow-hidden"
  >
    <UiBgSkewY />
    <UiContainer class="flex flex-col gap-6 lg:gap-11 relative z-10">
      <UiSectionTitle class="lg:text-center" title="Mekanisme COD Advance" />
      <UiCarouselFeature
        :items="carousels"
        hide-nav-button
        class-content-wrapper="overflow-visible"
      />
    </UiContainer>
  </div>
</template>
